import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _getPrototypeOf from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/get";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/focusobserver
 */

/* globals setTimeout, clearTimeout */
import DomEventObserver from './domeventobserver';
/**
 * {@link module:engine/view/document~Document#event:focus Focus}
 * and {@link module:engine/view/document~Document#event:blur blur} events observer.
 * Focus observer handle also {@link module:engine/view/rooteditableelement~RootEditableElement#isFocused isFocused} property of the
 * {@link module:engine/view/rooteditableelement~RootEditableElement root elements}.
 *
 * Note that this observer is attached by the {@link module:engine/view/view~View} and is available by default.
 *
 * @extends module:engine/view/observer/domeventobserver~DomEventObserver
 */

var FocusObserver = /*#__PURE__*/function (_DomEventObserver) {
  _inherits(FocusObserver, _DomEventObserver);

  var _super = _createSuper(FocusObserver);

  function FocusObserver(view) {
    var _this;

    _classCallCheck(this, FocusObserver);

    _this = _super.call(this, view);
    _this.domEventType = ['focus', 'blur'];
    _this.useCapture = true;
    var document = _this.document;
    document.on('focus', function () {
      document.isFocused = true; // Unfortunately native `selectionchange` event is fired asynchronously.
      // We need to wait until `SelectionObserver` handle the event and then render. Otherwise rendering will
      // overwrite new DOM selection with selection from the view.
      // See https://github.com/ckeditor/ckeditor5-engine/issues/795 for more details.
      // Long timeout is needed to solve #676 and https://github.com/ckeditor/ckeditor5-engine/issues/1157 issues.
      //
      // Using `view.change()` instead of `view.forceRender()` to prevent double rendering
      // in a situation where `selectionchange` already caused selection change.

      _this._renderTimeoutId = setTimeout(function () {
        return view.change(function () {});
      }, 50);
    });
    document.on('blur', function (evt, data) {
      var selectedEditable = document.selection.editableElement;

      if (selectedEditable === null || selectedEditable === data.target) {
        document.isFocused = false; // Re-render the document to update view elements
        // (changing document.isFocused already marked view as changed since last rendering).

        view.change(function () {});
      }
    });
    /**
     * Identifier of the timeout currently used by focus listener to delay rendering execution.
     *
     * @private
     * @member {Number} #_renderTimeoutId
     */

    return _this;
  }

  _createClass(FocusObserver, [{
    key: "onDomEvent",
    value: function onDomEvent(domEvent) {
      this.fire(domEvent.type, domEvent);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this._renderTimeoutId) {
        clearTimeout(this._renderTimeoutId);
      }

      _get(_getPrototypeOf(FocusObserver.prototype), "destroy", this).call(this);
    }
  }]);

  return FocusObserver;
}(DomEventObserver);
/**
 * Fired when one of the editables gets focus.
 *
 * Introduced by {@link module:engine/view/observer/focusobserver~FocusObserver}.
 *
 * Note that because {@link module:engine/view/observer/focusobserver~FocusObserver} is attached by the
 * {@link module:engine/view/view~View} this event is available by default.
 *
 * @see module:engine/view/observer/focusobserver~FocusObserver
 * @event module:engine/view/document~Document#event:focus
 * @param {module:engine/view/observer/domeventdata~DomEventData} data Event data.
 */

/**
 * Fired when one of the editables loses focus.
 *
 * Introduced by {@link module:engine/view/observer/focusobserver~FocusObserver}.
 *
 * Note that because {@link module:engine/view/observer/focusobserver~FocusObserver} is attached by the
 * {@link module:engine/view/view~View} this event is available by default.
 *
 * @see module:engine/view/observer/focusobserver~FocusObserver
 * @event module:engine/view/document~Document#event:blur
 * @param {module:engine/view/observer/domeventdata~DomEventData} data Event data.
 */


export { FocusObserver as default };